import { SummarizerConfig } from '../../types/summarizer';

export const googleDriveSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'google-drive-summarizer',
  title: 'Google Drive Summarizer',
  description: 'Summarize any file from Google Drive - docs, sheets, PDFs, and more',
  version: '1.0.0',
  
  // Categorization
  category: 'cloud',
  tags: ['google-drive', 'cloud-storage', 'documents', 'collaboration'],
  
  // Input configuration
  inputs: {
    file: {
      enabled: false // Google Drive files are accessed via URL
    },
    url: {
      enabled: true,
      placeholder: 'Enter Google Drive file share link',
      validation: /drive\.google\.com\/(file|drive|open)/,
      examples: [
        'https://drive.google.com/file/d/1ABC123.../view',
        'https://drive.google.com/open?id=1XYZ789...',
        'https://drive.google.com/drive/folders/1DEF456...'
      ],
      helpText: 'Share your Google Drive file with "Anyone with the link" permission and paste the link here.',
      showExamples: true,
      showHelpText: true
    }
  },
  
  // Output features
  outputs: {
    summary: true,
    chat: true,
    repurpose: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: false,
    download: true,
    share: true
  },
  
  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'google-drive',
    timeout: 30000
  },
  
  // UI customization
  ui: {
    primaryColor: '#4285f4',
    secondaryColor: '#34a853',
    icon: '📁',
    theme: 'light'
  },
  
  // Validation rules
  validation: {
    required: true,
    minSize: 0,
    maxSize: 0,
    allowedDomains: ['drive.google.com'],
    blockedDomains: []
  },
  
  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false
  },
  
  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01'
};